import React, { useState, useEffect } from 'react';
import { Bell } from 'lucide-react';
import api from '../services/api';

function NotificationBell({ user }) {
  const [notifications, setNotifications] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.getNotifications();
        setNotifications(res.data || []);
      } catch (err) {
        // Silently ignore — notification fetch failure should not block the page.
      }
    })();
  }, []);

  const unreadCount = notifications.filter(n => !n.is_read).length;

  const handleClick = async (n) => {
    if (n.is_read) return;
    try {
      await api.markNotificationRead(n.id);
      setNotifications(prev => prev.map(x => x.id === n.id ? { ...x, is_read: 1 } : x));
    } catch (err) {
      // Silently ignore — marking as read is best-effort.
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <button className="btn-secondary" onClick={() => setOpen(!open)} style={{ position: 'relative' }}>
        <Bell size={16} />
        {unreadCount > 0 && (
          <span style={{ position: 'absolute', top: '-4px', right: '-4px', background: '#A63A3A', color: '#fff', borderRadius: '9999px', fontSize: '0.65rem', padding: '0.1rem 0.35rem' }}>{unreadCount}</span>
        )}
      </button>
      {open && (
        <div style={{ position: 'absolute', right: 0, top: '100%', marginTop: '0.5rem', background: '#fff', border: '1px solid #D3DAD7', borderRadius: '0.5rem', width: '320px', maxHeight: '400px', overflowY: 'auto', zIndex: 50, boxShadow: '0 10px 25px rgba(0,0,0,0.1)' }}>
          {notifications.length === 0 && <div style={{ padding: '1rem' }}>Belum ada notifikasi.</div>}
          {notifications.map(n => (
            <div key={n.id} onClick={() => handleClick(n)} style={{ padding: '0.75rem 1rem', borderBottom: '1px solid #EEF1EF', cursor: 'pointer', background: n.is_read ? '#fff' : '#F2F5FA' }}>
              <div style={{ fontWeight: 600, fontSize: '0.85rem' }}>{n.title}</div>
              <div style={{ fontSize: '0.8rem', color: '#55636B' }}>{n.message}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default NotificationBell;
